import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientReference)?_c('div',[_c(VSelect,{attrs:{"disabled":!_vm.isStaff,"items":_vm.invoicesForClient,"label":"Select Invoice To Add To"},on:{"change":_vm.getSelectedInvoice},model:{value:(_vm.selectedInvoice),callback:function ($$v) {_vm.selectedInvoice=$$v},expression:"selectedInvoice"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }